import { Warning, Info } from "@phosphor-icons/react";

const SEVERITY_COLORS = { urgent: "#B4432F", attention: "#C99A2E" };

export function SeverityIcon({ severity, size = 17 }) {
  const color = SEVERITY_COLORS[severity];
  const Icon = color ? Warning : Info;
  return <Icon size={size} weight="fill" color={color || "#3B6AA0"} className="mt-0.5 shrink-0" />;
}

export function stockColorClass(qty, threshold) {
  if (qty <= 0) return "text-[#B4432F]";
  if (qty <= threshold) return "text-[#C99A2E]";
  return "text-[#2E7D5B]";
}

export function stockBadgeClass(qty, threshold) {
  if (qty <= 0) return "badge-unpaid";
  if (qty <= threshold) return "badge-partial";
  return "badge-paid";
}

const MOVE_COLORS = { correction: "text-[#C99A2E]", vente: "text-[#B4432F]" };

export function moveColorClass(type) {
  return MOVE_COLORS[type] || "text-[#2E7D5B]";
}

const PAY_TYPE_LABELS = { salaire: "Salaire", prime: "Prime", heures_sup: "Heures sup." };

export function payTypeLabel(type) {
  return PAY_TYPE_LABELS[type] || "Heures sup.";
}
